import { PlayerFilters } from '@/interfaces/filters/playerFilters';
import { Profile } from '@/interfaces/profile';
import { ProfileModule } from '../profile.module';
import medicalExamination from './player/medicalExamination.module';

/**
 * Moduł zawodników
 *
 * @export
 * @class PlayerModule
 * @extends {ProfileModule}
 */
export class PlayerModule extends ProfileModule {
  public modules = { medicalExamination };

  constructor() {
    super();
    this.actions = {
      ...this.actions,
      /**
       * Lista zawodników
       *
       * @param {*} context
       * @param {PlayerFilters} filters
       * @returns {Promise<Profile[]>}
       */
      list: (context: any, filters: PlayerFilters): Promise<Profile[]> => {
        return this.resource.playersList(filters).then(({ list, count }) => {
          context.commit('saveList', list);
          context.commit('saveCount', count);
          return list;
        });
      },
      /**
       * Dodaje zawodnika do store
       *
       * @param context context
       * @param data dane do zapisania w store
       */
      add: async (context: any, data: any): Promise<void> => {
        context.commit('add', data);
        context.commit('incrementCount');
      },
      /**
       * Usuwa zawodnika
       *
       * @param context context
       * @param id identyfikator zawodnika
       * @param {PlayerFilters} filters
       */
      remove: async (context: any, data: { id: number; filters: PlayerFilters }): Promise<void> => {
        await this.resource.delete(data.id);
        context.dispatch('list', data.filters);
      }
    };
  }
}

export default new PlayerModule();
